import React from 'react'
import nav_gp from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/nav_gp.svg'
import magento from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/magento.svg'
import bc from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/bcnew.png'
import EGE from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/EGE.svg'
import bigcommerce from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/bigcommerce.png'
import qb from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/qb_thumb.png'
import shopify from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/shopify.svg'
import { connectorImage } from '../../../features/marketplace/connectorImages'

const ICONS_BY_SHORT_NAME = {
    EGE,
    Magento: magento,
    Nav: nav_gp,
    GP: nav_gp,
    AX: nav_gp,
    BC: bc,
    'Business Central': bc,
    BigCommerce: bigcommerce,
    QuickBooks: qb,
    Shopify: shopify,
}

export const connectorIconSrc = (shortName) => ICONS_BY_SHORT_NAME[shortName] || connectorImage(shortName)

const ConnectorIcon = ({ shortName, className, fallbackClassName, decorative }) => {
    const src = connectorIconSrc(shortName)
    if (!src) {
        return <span className={fallbackClassName || className}>{shortName}</span>
    }
    return <img src={src} alt={decorative ? '' : shortName} className={className} loading="lazy" decoding="async" />
}

export default ConnectorIcon
